import { Button } from '@/components/common/button'
import { Note } from '@/components/common/note'
import { InfoIcon } from '@/components/icons/info'
import { formatBips } from '@vaultsfyi/common/utils'

const FALLBACK_MIDAS_URL = 'https://midas.app/'

interface MidasRedeemNoteProps {
  redeemFeeBips: number
  protocolVaultUrl?: string
}

export const MidasRedeemNote = ({ redeemFeeBips, protocolVaultUrl }: MidasRedeemNoteProps) => {
  const fee = formatBips(redeemFeeBips)
  return (
    <Note>
      <div className="flex items-center gap-2">
        <InfoIcon />
        <h6 className="font-bold">Instant redemption fee</h6>
      </div>
      <p className="text-xs">
        This vault has a {fee} fee applied on instant redemption. To use a standard delayed redemption, visit the{' '}
        <Button variant="default" size="default" className="rounded-full text-xs underline" asChild>
          <a href={protocolVaultUrl ?? FALLBACK_MIDAS_URL} target="_blank" rel="noreferrer">
            Midas app
          </a>
        </Button>
        .
      </p>
    </Note>
  )
}
